import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import c20v1a from './c20v1a'; // クライアント情報
import c42v1a from './c42v1a'; // 権限情報
import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報
import i1zv from './i1zv_20211024';

import myMQ from './myMQ_20211213';
import myPD from './myPD_20211208';
import myWB from './myWB_20211212';

export default class i1zv3 extends i1zv { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$id_stss = { //  子で上書き
  s_i1zri21d: ff.myDT_getDate('today'),
  //s_i1zri21d: '2022-04-27',
  sb_1050: false,　// 1050 の使用権限
};

$clp_loadLists = () => [ // 親を上書き
  c20v1a.op_loadDtl({
    elm: 'c20r',
  }),
  new Promise( _o_end1 => {
    if (global.t?.d_viewDefs.class == 'i1zv3a') {
      i11v1a.op_loadList({
        elm: 'i11r',
        dd_cldDefss: {
          i110: {
            elm: 'i110',
            o_cnd: _dd_datss => {
              let _cnd = cf.c('i110', `i110b51k = ${_dd_datss.i11r.d_flds._key}`, false, false);
              return _cnd;
            },
          },
        },
      })
      .then(() => {
        global.t?.state.sdld_i11rListsss.i11r.map( ( _d_i11rs, _i11rIdx) => {
          let _state = `sdld_i10rListsss${_d_i11rs.d_flds._fst}`;
          i10v1a.op_loadList({
            elm: 'i10r',
            state: _state,
            o_cnd: _dd_datss => {
              let _cnd = cf.c('i10r', `i10rb51f = ${_d_i11rs.d_flds._fst} AND i10rt11i = 200`)
              return _cnd;
            },
            dd_cldDefss: {
              i110: {
                elm: 'i110',
                o_cnd: _dd_datss => {
                  let _cnd = cf.c('i110', `i110b51k = ${_d_i11rs.d_flds._key}`, false, false) // 指定した利用日に紐づく予約情報
                  return _cnd;
                },
                dd_cldDefss: {
                  i1z0: {
                    elm: 'i1z0',
                    o_cnd: _dd_datss => {
//                      let _cnd = cf.c('i1z0', `i1z0i21d = "${global.t?.state.s_i1zri21d}" AND i1z0b41f = ${_dd_datss.i10r.d_flds._fst} AND i1z0b51f = ${_dd_datss.i110.d_flds._fst} AND i1z0s11i IN (80, 90)`) // 指定した利用日に紐づく予約情報
                      let _cnd = cf.c('i1z0', `i1z0i21d = "${global.t?.state.s_i1zri21d}" AND i1z0b41f = ${_dd_datss.i10r.d_flds._fst} AND i1z0b51f = ${_dd_datss.i110.d_flds._fst} AND i1z0s11i IN (80, 90) AND EXISTS (SELECT * FROM t_i1zr WHERE t_i1zr._key = t_i1z0.i1z0b61k AND t_i1zr._vsn = t_i1zr._ltt)`) // 指定した利用日に紐づく予約情報
//ff.l('i1zv3 74: {}'.f(_cnd))
                      return _cnd;
                    },
                    dd_rfrss: {
                      i1zr: {
                        elm: 'i1zr',
                        o_cnd: _d_flds => {
                          let _cnd = cf.c('i1zr', `_key = ${_d_flds.i1z0b61k} AND i1zrs11i IN (80, 90)`, false, false) // 指定した利用日に紐づく予約情報
                          return _cnd;
                        },
                        dd_rfrss: {
                          'c30r': {
                            elm: 'c30r',
                            o_cnd: _d_flds => {
                              let _cnd = cf.c('c30r', `_fst = ${_d_flds.i1zrb31f}`);
                              return _cnd;
                            },
                          },
                        },
                        dd_cldDefss: {
                        },
                      },
                    },
                  },
                },
              },
            },
            op_atrAll: () => new Promise( _o_end2 => { 
              if (global.t?.state[_state]) {
                global.t?.setState({
                  [_state]: bf.p(global.t?.state[_state], _next => {
                    _next.i10r.map( (_d_i10rs, _idxI10r) => {
                      _d_i10rs.d_tbls = { pfx: _d_i10rs.d_flds.i10rc31s, d_is: {} };
                      _d_i10rs.dld_cldDatsss.i110.map( (_d_i110s, _i110Idx) => { // ctg
                        let _d_i1z0s = (ff.f(_d_i110s.dld_cldDatsss.i1z0)) ? _d_i110s.dld_cldDatsss.i1z0[0] : null;
                        if (global.t?.d_viewDefs.class == 'i1zv3a') {
                          if (_d_i1z0s) {
                            _d_i10rs.d_tbls.d_is[`${_d_i110s.d_flds._key}`] = 
                              {
                                pfx: _d_i1z0s.d_flds.c30rc31s,
                                sfx: ((_d_i1z0s.d_flds.i1zrt41i == 10) ? '【備○】' : '') + _d_i1z0s.d_flds.i1zri41s,
                                i1zr_fst: _d_i1z0s.d_flds.i1zr_fst,
                              }
                          }
                          else { 
                            _d_i10rs.d_tbls.d_is[`${_d_i110s.d_flds._key}`] = 
                              {
                                pfx: '',
                                sfx: '',
                                i1zr_key: -1,
                              }
                          };
                        }
                        if (global.t?.d_viewDefs.class == 'i1zv3b') {
                          if (_d_i1z0s) {
                            _d_i10rs.d_tbls.d_is[`${_d_i110s.d_flds._key}.i110c31s`] = 
                              {
                                pfx: _d_i110s.d_flds.i110c31s,
                              }
                            _d_i10rs.d_tbls.d_is[`${_d_i110s.d_flds._key}.c30rc31s`] = 
                              {
                                pfx: _d_i1z0s.d_flds.c30rc31s,
                              }
                          }
                          else { 
                            _d_i10rs.d_tbls.d_is[`${_d_i110s.d_flds._key}.i110c31s`] = 
                              {
                                pfx: _d_i110s.d_flds.i110c31s,
                              }
                            _d_i10rs.d_tbls.d_is[`${_d_i110s.d_flds._key}.c30rc31s`] = 
                              {
                                pfx: ``,
                              }
                          };
                        }
                      })
                    })
                  }),
                }, () => {
                  _o_end2();
                });
              }
              else {
                _o_end2();
              }
            }),
          })
        });
        _o_end1();
      })
    };
    if (global.t?.d_viewDefs.class == 'i1zv3b') {
      i11v1a.op_loadList({
        elm: 'i11r',
        dd_cldDefss: {
          i10r: {
            elm: 'i10r',
            o_cnd: _dd_datss => {
              let _cnd = cf.c('i10r', `i10rb51f = ${_dd_datss.i11r.d_flds._fst} AND i10rt11i = 200`)
              return _cnd;
            },
          },
        },
      })
      .then(() => {
        global.t?.state.sdld_i11rListsss.i11r.map( ( _d_i11rs, _i11rIdx) => {
          let _state = `sdld_i110Listsss${_d_i11rs.d_flds._fst}`;
          i11v1a.op_loadList({
            elm: 'i110',
            state: _state,
            o_cnd: _dd_datss => {
              let _cnd = cf.c('i110', `i110b51k = ${_d_i11rs.d_flds._key}`, false, false)
              return _cnd;
            },
            dd_cldDefss: {
              i10r: {
                elm: 'i10r',
                o_cnd: _dd_datss => {
                  let _cnd = cf.c('i10r', `i10rb51f = ${_d_i11rs.d_flds._fst} AND i10rt11i = 200`)
                  return _cnd;
                },
                dd_cldDefss: {
                  i1z0: {
                    elm: 'i1z0',
                    o_cnd: _dd_datss => {
                      //let _cnd = cf.c('i1z0', `i1z0i21d = "${global.t?.state.s_i1zri21d}" AND i1z0b41f = ${_dd_datss.i10r.d_flds._fst} AND i1z0b51f = ${_dd_datss.i110.d_flds._fst} AND i1z0s11i IN (80, 90)`) // 指定した利用日に紐づく予約情報
                      let _cnd = cf.c('i1z0', `i1z0i21d = "${global.t?.state.s_i1zri21d}" AND i1z0b41f = ${_dd_datss.i10r.d_flds._fst} AND i1z0b51f = ${_dd_datss.i110.d_flds._fst} AND i1z0s11i IN (80, 90) AND EXISTS (SELECT * FROM t_i1zr WHERE t_i1zr._key = t_i1z0.i1z0b61k AND t_i1zr._vsn = t_i1zr._ltt)`) // 指定した利用日に紐づく予約情報
                      return _cnd;
                    },
                    dd_rfrss: {
                      i1zr: {
                        elm: 'i1zr',
                        o_cnd: _d_flds => {
                          let _cnd = cf.c('i1zr', `_key = ${_d_flds.i1z0b61k} AND i1zrs11i IN (80, 90)`, false, false) // 指定した利用日に紐づく予約情報
                          return _cnd;
                        },
                        dd_rfrss: {
                          'c30r': {
                            elm: 'c30r',
                            o_cnd: _d_flds => {
                              let _cnd = cf.c('c30r', `_fst = ${_d_flds.i1zrb31f}`);
                              return _cnd;
                            },
                          },
                        },
                        dd_cldDefss: {
                        },
                      },
                    },
                  },
                },
              },
            },
            op_atrAll: () => new Promise( _o_end2 => { 
              if (global.t?.state[_state]) {
                global.t?.setState({
                  [_state]: bf.p(global.t?.state[_state], _next => {
                    _next.i110.map( _d_i110s => {
                      //_d_i110s.d_tbls = { pfx: _d_i110s.d_flds.i110c31s, sfx: `${_d_i110s.d_flds.i110i11t}:00 〜 ${_d_i110s.d_flds.i110i12t}:00`, d_is: {} };
                      _d_i110s.d_tbls = { pfx: _d_i110s.d_flds.i110c31s, d_is: {} }; // 時間帯を非表示 sfx: `${_d_i110s.d_flds.i110i11t}:00 〜 ${_d_i110s.d_flds.i110i12t}:00`
                      _d_i110s.dld_cldDatsss?.i10r?.map( _d_i10rs => { // ctg
                        let _d_i1z0s = (ff.f(_d_i10rs.dld_cldDatsss.i1z0)) ? _d_i10rs.dld_cldDatsss.i1z0[0] : null;
                        if (_d_i1z0s) {
//ff.l('i1zv3 233: {}, {}, {}, {}'.f(_d_i10rs.d_flds._key, _d_i10rs.d_flds.i10rc31s, _d_i1z0s.d_flds.c30rc31s, _d_i1z0s));
                          _d_i110s.d_tbls.d_is[`${_d_i10rs.d_flds._key}.c30rc31s`] = 
                            {
                              pfx: _d_i10rs.d_flds.i10rc31s,
                            }
                          _d_i110s.d_tbls.d_is[`${_d_i10rs.d_flds._key}.i110c31s`] = 
                            {
                              pfx: _d_i1z0s.d_flds.c30rc31s,
                            }
                        }
                        else { 
//ff.l('i1zv3 244: here');
                          _d_i110s.d_tbls.d_is[`${_d_i10rs.d_flds._key}.c30rc31s`] = 
                            {
                              pfx: _d_i10rs.d_flds.i10rc31s,
                            }
                          _d_i110s.d_tbls.d_is[`${_d_i10rs.d_flds._key}.i110c31s`] = 
                            {
                              pfx: ``,
                            }
                        };
//ff.l('i1zv3 252: {}'.f(_d_i110s.d_tbls));
                      })
                    })
                  }),
                }, () => {
                  _o_end2();
                });
              }
              else {
                _o_end2();
              }
            }),
          })
        });
        _o_end1();
      });
    };
  }),
  new Promise( _o_end1 => { // get c40r
    c42v1a.getC40rsAsync({
      c10r_key: global.t?.state.sgcd_cmnStgs.c10r_key,
    })
    .then( _l => {
      let _b_1050 = false;
      _l.map( _d => {
        if (_d.c40rc11s == '1050') _b_1050 = true;
      });
      global.t?.setState({
        sb_1050: _b_1050,
      }, ()=> {
        _o_end1(null);
      });
    });
  }),
];

_eptPdf1 = () => {

  cf.s();

  let _file = `使用状況_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`;
  let _ld_iss = [];

  let _n_w = 54;
  let _n_lblW = 10;
  let _n_hdrH = 2;
  let _n_bdyH = 6;

  let _n_row = 0;
  _ld_iss.push({ type: 'text', pfx: `使用状況一覧`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 27, n_rowCnt: 2, aln: 'ctr', b_frm: false, n_size: 1.2, b_bold: true });
  _ld_iss.push({ type: 'text', pfx: ff.myDT_cnv('西暦月日', global.t?.state.s_i1zri21d),  n_cmn: 28, n_row: _n_row, n_cmnCnt: 27, n_rowCnt: 2, aln: 'ctr', b_frm: false, n_size: 1, b_bold: true });
  _n_row +=3;

  global.t?.state.sdld_i11rListsss?.i11r.map( ( _d_i11rs, _i11rIdx) => {
    let _state = `sdld_i10rListsss${_d_i11rs.d_flds._fst}`;
    if (ff.myCM_getLen(global.t?.state[_state]?.i10r) > 0) {
      let _n_cmn = _n_lblW + 1;
      let _n_cmnW = (_n_w - _n_lblW) /  ff.myCM_getLen(_d_i11rs.dld_cldDatsss.i110);
      _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => {
        _ld_iss.push({ type: 'text', pfx: _d_i110s.d_flds.i110c31s,  n_cmn: _n_cmn, n_row: _n_row, n_cmnCnt: _n_cmnW, n_rowCnt: _n_hdrH, aln: 'ctr', b_frm: true, n_size: 1.0, b_bold: false });
        _n_cmn += _n_cmnW;
      })
      _n_row += _n_hdrH;

      global.t?.state[_state].i10r.map( _d_i10rs => {
//        _ld_iss.push({ type: 'text', pfx: _d_i10rs.d_flds.i10rc31s,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 10, n_rowCnt: 2, aln: 'ctr', b_frm: true, n_size: 1.0, b_bold: false });
        _ld_iss.push({ type: 'text', pfx: _d_i10rs.d_flds.i10rc31s,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 10, n_rowCnt: _n_bdyH, aln: 'ctr', b_frm: true, n_size: 1.0, b_bold: false });

        let _n_cmn = _n_lblW + 1;
        _d_i10rs.dld_cldDatsss?.i110?.map( _d_i110s => {
          let _d_i1z0s = (ff.f(_d_i110s.dld_cldDatsss?.i1z0)) ? _d_i110s.dld_cldDatsss?.i1z0[0] : null;
          let _pfx = (_d_i1z0s) ? _d_i1z0s.d_flds.c30rc31s: '';
//          _ld_iss.push({ type: 'text', pfx: _pfx,  n_cmn: _n_cmn, n_row: _n_row, n_cmnCnt: _n_cmnW, n_rowCnt: _n_bdyH, aln: 'ctr', b_frm: true, b_mln: true, n_size: 1.0, b_bold: false });
          _ld_iss.push({ type: 'text', pfx: _pfx,  n_cmn: _n_cmn, n_row: _n_row, n_cmnCnt: _n_cmnW, n_rowCnt: _n_bdyH, aln: 'ctr', b_frm: true, b_mln: true, n_size: 1.0, b_bold: false });
          _n_cmn += _n_cmnW;
        });

        _n_row += _n_bdyH;
      });
      _n_row += 1;
    };
  });

  _ld_iss.push({ type: 'pstCvsToPdf' });
  _ld_iss.push({ type: 'savePdf' });

  myPD.myPD_dwlFile({
    file: _file,
    ld_iss: _ld_iss,
    d_inis: {
      orientation: 'portrait',
    },
  })
  .then(() => {
    cf.h();
  });
};

_eptPdf2 = () => {
  cf.s();

  let _file = `部屋別掲示_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`;
  let _ld_iss = [];

  let _n_cnt = 0;  
  let _n_row = 0;
  global.t?.state.sdld_i11rListsss?.i11r.map( ( _d_i11rs, _i11rIdx) => {

    let _state = `sdld_i10rListsss${_d_i11rs.d_flds._fst}`;
    global.t?.state[_state].i10r.map( _d_i10rs => {

      _n_cnt += 1;
      if (_n_cnt > 1) {
        _ld_iss.push({ type: 'clrCvs' });
        _ld_iss.push({ type: 'addNewPageToPdf' });
      };

      _n_row = 1;
      _ld_iss.push({ type: 'text', pfx: _d_i10rs.d_flds.i10rc31s,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 36, n_rowCnt: 3, aln: 'ctr', b_frm: false, n_size: 2.8, b_bold: true });
      _ld_iss.push({ type: 'text', pfx: ff.myDT_cnv('西暦月日', global.t?.state.s_i1zri21d),  n_cmn: 37, n_row: _n_row, n_cmnCnt: 41.5, n_rowCnt: 3, aln: 'ctr', b_frm: false, n_size: 1.8, b_bold: true });

      _n_row = 5;
      let _n_bdyH = (34 - 5) / ff.myCM_getLen(_d_i10rs.dld_cldDatsss.i110);
      _d_i10rs.dld_cldDatsss.i110.map( _d_i110s => {
        let _d_i1z0s = (ff.f(_d_i110s.dld_cldDatsss?.i1z0)) ? _d_i110s.dld_cldDatsss?.i1z0[0] : null;
        let _pfx = (_d_i1z0s) ? _d_i1z0s.d_flds.c30rc31s: '';
        //_ld_iss.push({ type: 'text', pfx: '',  n_cmn: 1, n_row: _n_row, n_cmnCnt: 20, n_rowCnt: _n_bdyH, aln: 'ctr', b_frm: true });
        //_ld_iss.push({ type: 'text', pfx: _d_i110s.d_flds.i110c31s,  n_cmn: 1, n_row: _n_row + (_n_bdyH - (2.2 + 1.4)) / 2, n_cmnCnt: 20, n_rowCnt: 2.2, aln: 'ctr', b_frm: false, n_size: 1.8, b_bold: true });
        _ld_iss.push({ type: 'text', pfx: _d_i110s.d_flds.i110c31s,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 20, n_rowCnt: _n_bdyH, aln: 'ctr', b_frm: true, n_size: 1.8, b_bold: true });
        //_ld_iss.push({ type: 'text', pfx: `${_d_i110s.d_flds.i110i11t}:00〜${_d_i110s.d_flds.i110i12t}:00`,  n_cmn: 1, n_row: _n_row + (_n_bdyH - (2.2 + 1.4)) / 2 + 2.2, n_cmnCnt: 20, n_rowCnt: 1.4, aln: 'ctr', b_frm: false, n_size: 1.4, b_bold: true });
        _ld_iss.push({ type: 'text', pfx: _pfx,  n_cmn: 21, n_row: _n_row, n_cmnCnt: 57.5, n_rowCnt: _n_bdyH, aln: 'ctr', b_frm: true, n_size: 1.8, b_bold: true });
        _n_row += _n_bdyH;
      });

      _ld_iss.push({ type: 'pstCvsToPdf' });

    });
  });

  _ld_iss.push({ type: 'savePdf' });

  myPD.myPD_dwlFile({
    file: _file,
    ld_iss: _ld_iss,
    d_inis: {
      orientation: 'landscape',
    },
  })
  .then(() => {
    cf.h();
  });
};

// $opb_chk, render は個別に実装

render() {

  let _r = [];

  if (global.t?.d_viewDefs.class == 'i1zv3a') {

    global.t?.state.sdld_i11rListsss?.i11r.map( ( _d_i11rs, _i11rIdx) => {

      let _state = `sdld_i10rListsss${_d_i11rs.d_flds._fst}`;

      if (global.t?.state[_state]?.i10r && ff.myCM_getLen(global.t?.state[_state].i10r) > 0){

        let _l_cmns = [];
        let _n_lblW = 
          (global.t?.d_viewDefs.class == 'i1zv3a') ?
            ic.s(2 * 4)
          : (global.t?.d_viewDefs.class == 'i1zv3b') ?
            ic.s(2 * 8)
          : null;
        let _n_cnt = ff.myCM_getLen(_d_i11rs.dld_cldDatsss.i110);
        let _n_w2 = ic.s(2 * 3);

        let _n_w1 = 
          (global.t?.d_viewDefs.class == 'i1zv3a') ?
            (ic.gn_bdyW - _n_lblW) / _n_cnt
          : (global.t?.d_viewDefs.class == 'i1zv3b') ?
            (ic.gn_bdyW - _n_lblW - _n_w2 * 2) / 2
          : null;

        _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => {
          if (global.t?.d_viewDefs.class == 'i1zv3a') {
            _l_cmns.push(`${_d_i110s.d_flds._key}`);
          }
          if (global.t?.d_viewDefs.class == 'i1zv3b') {
            _l_cmns.push(`${_d_i110s.d_flds._key}.i110c31s`);
            _l_cmns.push(`${_d_i110s.d_flds._key}.c30rc31s`);
          }
        });

        _r.push(
          ce.c(ce.Box, {
            key: _i11rIdx,
            n_mgnTop: ic.s(1),
          }, 
            ce.c(ce.Tbl2, {
              key: _i11rIdx,
              b_vsb: true,
              b_hdr: 
                (global.t?.d_viewDefs.class == 'i1zv3a') ?
                  true
                : (global.t?.d_viewDefs.class == 'i1zv3b') ?
                  false
                : false,
              b_ctg: true,
              b_tgt: false,
              state: _state,        
              n_cmn: 
                (global.t?.d_viewDefs.class == 'i1zv3a') ?
                  0
                : (global.t?.d_viewDefs.class == 'i1zv3b') ?
                  4
                : 0,
              l_cmns: _l_cmns,
              o_pfx: _cmn => {
                let _pfx = 
                  (global.t?.d_viewDefs.class == 'i1zv3a') ?
                    ff.myCM_getDny({
                      ld_iss: _d_i11rs.dld_cldDatsss.i110, 
                      fld: 'key', 
                      val: ff.n(_cmn),
                    }).d_flds.i110c31s
                  : (global.t?.d_viewDefs.class == 'i1zv3b') ?
                    null
                  : null;
                return _pfx;
              },
              od_stlLbls: () => {
                let _d = 
                  {
                    flex: null,
                    width: _n_lblW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  };
                return _d;          
              },
              od_stlLblPfxs: () => {
                let _d = 
                  (global.t?.d_viewDefs.class == 'i1zv3a')?
                    {
                      flex: null,
                      width: _n_lblW,
                      fontSize: ic.s(1),
                    }
                  : (global.t?.d_viewDefs.class == 'i1zv3b')?
                    {
                      fontSize: ic.s(2),
                    }
                  : null;
                return _d;          
              },
              od_stlCells: (_cmn) => {
                let _d = 
                  (global.t?.d_viewDefs.class == 'i1zv3a')?
                    {
                      //flex: _n_w1,
                      flex: null,
                      width: _n_w1,
                    }
                  : (global.t?.d_viewDefs.class == 'i1zv3b' && _cmn.substr(-8) == 'i110c31s')?
                    {
                      flex: _n_w2,
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                    }
                  : (global.t?.d_viewDefs.class == 'i1zv3b' && _cmn.substr(-8) == 'c30rc31s')?
                    {
                      flex: _n_w1,
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                    }
                  : null;
                return _d;
              },
              od_stlCellPfxs: (_cmn) => {
                let _d = 
                  (global.t?.d_viewDefs.class == 'i1zv3a')?
                    {
                      flex: null,
                      width: _n_w1,
                      fontSize: ic.s(1),
                    }
                  : (global.t?.d_viewDefs.class == 'i1zv3b' && _cmn.substr(-8) == 'i110c31s')?
                    {
                      fontSize: ic.s(1.3),
                    }
                  : (global.t?.d_viewDefs.class == 'i1zv3b' && _cmn.substr(-8) == 'c30rc31s')?
                    {
                      fontSize: ic.s(2),
                    }
                  : null;
                return _d;          
              },
              od_stlCellSfxs: (_cmn) => {
                let _d = 
                  (global.t?.d_viewDefs.class == 'i1zv3a')?
                    {
                      flex: null,
                      width: _n_w1,
                    }
                  : null;
                return _d;          
              },
              o_onCtgCellPrs: 
                global.t?.state.sb_1050 == true ?
                (_d_is) => {
                  let _i1zr_fst = _d_is.i1zr_fst;
                  if ( _i1zr_fst > 0 ) {
                    let _d_pageInfs = {
                      sgc_pageName: 'i1zv1a',
                      sgc_pageRole: global.t?.state.sgc_pageRole,
                      sgc_pageMode: 'show',
                      sgc_pnlMode: 'dtl',
                      sgc_pageFst: _i1zr_fst,
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  };
                }
                : null,
            })
          ),
        );

      }

    });
  };

  if (global.t?.d_viewDefs.class == 'i1zv3b') {

    global.t?.state.sdld_i11rListsss?.i11r    
    .filter( _d_i11rs => ff.f(_d_i11rs.dld_cldDatsss.i10r) ? true : false)
    .map( ( _d_i11rs, _i11rIdx) => {

      let _state = `sdld_i110Listsss${_d_i11rs.d_flds._fst}`;

      if (global.t?.state[_state]?.i110 && ff.myCM_getLen(global.t?.state[_state].i110) > 0){

        let _l_cmns = [];
        let _n_lblW = ic.s(16);
        let _n_w2 = ic.s(16);

        let _n_w1 = (ic.gn_bdyW - _n_lblW - _n_w2 * 2) / 2

        let _d_cmns = {};
        _d_i11rs.dld_cldDatsss.i10r.map( _d_i10rs => {
          let _cmn = `${_d_i10rs.d_flds._key}.i110c31s`;
          _l_cmns.push(_cmn);
          _d_cmns[_cmn] = _d_i10rs.d_flds.i10rc31s;
        });

        _r.push(
          ce.c(ce.Box, {
            key: _i11rIdx,
            n_mgnTop: ic.s(1),
          }, 
            ce.c(ce.Tbl2, {
              key: _i11rIdx,
              b_vsb: true,
              b_hdr: true,
              b_ctg: true,
              b_tgt: false,
              state: _state,        
              n_cmn: 4,
              l_cmns: _l_cmns,
              o_pfx: _cmn => _d_cmns[_cmn],
              od_stlLbls: () => {
                let _d = 
                  {
                    flex: null,
                    width: _n_lblW,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  };
                return _d;          
              },
              od_stlLblPfxs: () => {
                let _d = {
                  fontSize: ic.s(1.6),
                };
                return _d;          
              },
              od_stlCells: (_cmn) => {
                let _d = {
                  flex: _n_w2,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  borderLeftWidth: ic.b(0.5),
                  borderColor: ic.g_ccdHP,
                };
                return _d;
              },
              od_stlCellPfxs: (_cmn) => {
                let _d = 
                  (_cmn.substr(-8) == 'i110c31s')?
                    {
                      fontSize: ic.s(1.6),
//                      backgroundColor: 'red',
                    }
                  : (_cmn.substr(-8) == 'c30rc31s')?
                    {
                      fontSize: ic.s(2),
                    }
                  : null;
                return _d;          
              },
              od_stlCellSfxs: (_cmn) => null,
              od_stlHdrRows: () => {
                let _d = {
                  borderLeftWidth: ic.b(0.5),
                  borderRightWidth: ic.b(0.5),
                  borderColor: ic.g_ccdHP,
                };
                return _d;
              },
              od_stlCtgRows: () => {
                let _d = {
                  borderLeftWidth: ic.b(0.5),
                  borderRightWidth: ic.b(0.5),
                  borderColor: ic.g_ccdHP,
                };
                return _d;
              },
              numberOfLines: 2,
            })
          ),
        );

      }

    });

  };

  return (
    /* ----------------------------------------------------------------------------------------------------
    スタッフ用 使用状況
    ---------------------------------------------------------------------------------------------------- */
    (global.t?.d_viewDefs.class == 'i1zv3a') ?
      ce.c(ce.RootDtl, 
        {
          key: -1,
          d_hdrs: {
            d_subs: 
              ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
                {
                  iconName: 'users',
                  pfx: 'ユーザ切替',
                  o_onPrs: () => {
                    let _d_pageInfs = {
                      sgc_pageRole: global.t?.state.sgc_pageRole,
                      sgc_pageName: 'c00v2a',
                      sgc_pageMode: 'show',
                    };
                    cf.myRN_move_fwd(_d_pageInfs);
                  },
                }
              : null,
          },
          d_bdys: {
            l_clds: [

              // list ---------------------------------------------------------------------------------------------------
              ce.c(ce.Pnl, {
                key: -1,
                mode: 'list',
                b_vsb: global.t?.state.sgc_pnlMode == 'list' ? true : false,
                d_hdrs: {
                  d_ctrs: {
                    l_clds: [
                      ce.c(ce.PckDate, cf.f('i1zri21d', { // 利用日
                        key: -1, 
                        b_vsb: true,
                        b_edit: true,
                        b_row: true,
                        b_rvs: true,
                        state: 's_i1zri21d',
                        n_col: 7,
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        }
                      })),
                      ce.c(ce.BtnIconPfx, {
                        key: -6, 
                        b_vsb: true,
                        b_row: (ic.g_dvcMode == 's' ) ? false : true,
                        iconName: 'search',
                        pfx: '検索',
                        o_onPrs: () => global.t?.op_loadListAll(),
                        d_stlCtas: {
                          marginLeft: ic.m(1),
                        }
                      }),
                    ],
                  },
                  d_lefts: {
                    l_clds: [
                      ce.c(ce.BtnIconPfx, {
                        key: -3,
                        pfx: '使用状況一覧（PDF）',
                        b_vsb: true,
                        b_row: true,
                        iconName: 'file-o',
                        o_onPrs: global.t?._eptPdf1,
                        d_stlCtas: {
                          marginLeft: ic.s(1),
                        },
                      }),
                      ce.c(ce.BtnIconPfx, {
                        key: -2,
                        pfx: '部屋別掲示（PDF）',
                        b_vsb: true,
                        b_row: true,
                        iconName: 'file-o',
//                        o_onPrs: global.t?._eptPdf2,
                        o_onPrs: () => {
                          console.log('I1zv3 787: here')
                          global.t?._eptPdf2()
                        },
                        d_stlCtas: {
                          marginLeft: ic.s(1),
                        },
                      }),
                    ],
                  },
                  d_rhts: {
                    l_clds: [
                      ce.c(ce.BtnIconPfx, {
                        key: -1,
                        pfx: 'サイネージ',
                        b_vsb: true,
                        b_row: true,
                        iconName: 'square-o',
                        o_onPrs: () => {
                          let _url = String(ic.g_dmn).f(myWB.myWB_getDmn().subDmn) + '/i1zv3b';
                          myWB.myWB_open(_url);
                        },
                        d_stlCtas: {
                          marginRights: ic.s(1),
                        },
                      })
                    ],
                  },
                },
                d_bdys: {
                  l_clds:                 
                    _r
                },
              }),

            ],
          }
        }
      )
    /* ----------------------------------------------------------------------------------------------------
    スタッフ用 サイネージ
    ---------------------------------------------------------------------------------------------------- */
    : (global.t?.d_viewDefs.class == 'i1zv3b') ?
        ce.c(ce.RootDtl, 
          {
            key: -2,
            d_hdrs: {
              b_vsb: true,
//              pfx: '施設使用状況',
//              pfx: `${global.t?.state.sgcd_cmnStgs?.c20r_pfx}　${ff.myDT_cnv('西暦月日', ff.myDT_getDate('today'))} ${ff.myDT_getNow().substr(11,5)} 現在の使用状況`,
              pfx: `${global.t?.state.sgcd_cmnStgs?.c20r_pfx}　${ff.myDT_cnv('西暦月日', ff.myDT_getDate('today'))} ${ff.myDT_getNow().substr(11,5)}　本日の使用状況`,
              d_stlPfxs: {
                fontSize: ic.s(2.0),
              },
              d_stlCtrs: {
                backgroundColor: '#0047AB',
              },
              b_c10r_pfx: false,
            },
            d_bdys: {
              l_clds: [

                ce.c(ce.Bgg, {
                  key: -10,
                  uri: `${ic.g_url2}/signage.jpeg`,
                }, [

                  ce.c(myMQ.Tcr, {
                    key: -10,
                    pfx: `${global.t?.state.sgcd_stgs?._04010100 ?? ''}`,
                    d_stlPfxs: {
                      fontSize: ic.s(2),
                      color: ic.g_ccdWN,
                      width: '100%',
                    },
                    d_stlCtas: {
                      backgroundColor: '#0096FF',
                    },
                  }),

                  ce.c(ce.Pnl, {
                    key: -20,
                    mode: 'list',
                    b_vsb: global.t?.state.sgc_pnlMode == 'list' ? true : false,
                    d_stlCtas: {
                      height: ic.gn_h - ic.gn_hdrH * 2, // 20211202
                    },
                    d_hdrs: {
                      b_vsb: false,
                    },
                    d_bdys: {
                      l_clds: [
                        _r
                      ],
                    },
                  }),
                ])
              ],
            }
          }
        )
    :null
  );
}

}
